import AddressEditor from '@app/components/AddressEditor'
import { Address, IAddress } from '@app/models/Address'
import { AddressType } from '@app/models/enums'
import {
  IGlobalConfigurationState,
  IGlobalPlacesState,
} from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { sortByKey } from '@app/utils/sorting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import { Button } from 'reactstrap'

interface IComponentProps {
  dataSource?: List<IAddress>
  onChange: (e: any) => void
}

interface IComponentState {
  addressItems: List<IAddress>
}

export default class AddressList extends React.PureComponent<
  IComponentProps & IGlobalConfigurationState & IGlobalPlacesState,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    this.state = {
      addressItems: this.props.dataSource || List<IAddress>(),
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <div className='d-flex flex-column'>
        <Button
          size='sm'
          className='mt-1 mb-2 mr-auto'
          onClick={() => this._addAddressItem()}
          color='primary'
        >
          <FontAwesomeIcon icon={['fal', 'plus']} fixedWidth />
          <span>Address</span>
        </Button>
        {this._renderAddressItems()}
      </div>
    )
  }

  private _renderAddressItems() {
    return this.state.addressItems.map((p: any, i: any) => {
      return (
        <AddressEditor
          key={`address-${i}`}
          className={i === 0 ? 'mt-2' : 'mt-5'}
          onChange={(addr: Address) => this._editAddress(addr, i)}
          onRemoveAddressItem={() => this._removeAddressItem(i)}
          renderAddressType={true}
          value={p}
        />
      )
    })
  }

  private _removeAddressItem(index: number) {
    let items = this.state.addressItems.remove(index)
    items = sortByKey(items, 'addressIndex')

    this.props.onChange(items)

    this.setState({
      addressItems: items,
    })
  }

  private _addAddressItem() {
    let items = this.state.addressItems

    items = items.push(
      new Address({
        addressIndex: items.size + 1,
        attention: '',
        city: '',
        line1: '',
        line2: '',
        state: '',
        type: AddressType.Office,
        zip: '',
      }),
    )

    this.props.onChange(items)

    this.setState((prevState) => ({
      addressItems: items,
    }))
  }

  private _editAddress(newValue: Address, index: number) {
    const newAddressItems = this.state.addressItems.set(index, newValue)

    this.props.onChange(newAddressItems)
    this.setState({ addressItems: newAddressItems })
  }
}
